import { EventEmitter } from 'events';
import dispatcher from '../dispatcher/dispatcher';
import uuidv1 from 'uuid/v1';
import { getTreeFromDb, deleteTable } from '../services/publishData';
import userStore from './userStore';


/**
 * Table store which stores the table details
 * used whenever a table is taking form the api
 */
class TableStore extends EventEmitter {
    constructor() {
        super();
        this.table = { id: "", name: "", user: "", publish: false, templates: [] };
        this.avTables = {};
        this.publishTables = [];
    }
    //@TODO hook this up to some sort of user auth
    createTable(tableName) {
        let id = uuidv1();
        this.table = { id: id, tableName: tableName, user: userStore.user.id, templates: [], theme: [] };
        this.emit("Table-Changes");
    }
    setTable(tableObj) {
        this.table = tableObj.table;
        this.emit("Table-Changes");
    }
    setTableName(tableName) {
        this.table.tableName = tableName;
        this.emit("Table-Changes");
    }
    setPublish() {
        this.table.publish = true;
        this.emit("Table-Changes");
    }
    async setAvTables(tableObj) {
        // this.avTables = {};
        // await Object.keys(tableObj).forEach((element) => {
        //     this.avTables[element] = tableObj[element];
        // });
        this.emit("Available-Tables");

        // this.avTables.push(tableObj);
    }
    async setPublishTables(tableObj) {
        this.publishTables = tableObj;
        this.emit("Publish-Tables");
    }
    /**
     * if the table can be published and is published it changes it
     * @param {*} id of the table to change
     */
    changeToPublished(id) {
        let updateTree = this.publishTables.filter((pTables) => {
            return pTables.id === id;
        });
        const index = this.publishTables.indexOf(updateTree[0]);
        updateTree[0].publish = false;
        this.publishTables.splice(index, 1, updateTree[0]);
        this.emit("Publish-Tables");
    }
    loadTable(tableId) {
        getTreeFromDb(tableId);
    }
    deleteTables(tableId) {
        deleteTable(tableId);
    }
    actionHandler(action) {
        switch (action.type) {
            case 'SET_TABLE': {
                this.setTable(action.object);
                break;
            }
            case 'SET_TABLE_NAME': {
                this.setTableName(action.object);
                break;
            }
            case 'CREATE_TABLE': {
                this.createTable(action.object);
                break;
            }
            case 'SET_AV_TABLES': {
                this.setAvTables(action.object);
                break;
            }
            case 'CHANGE_PUBLISH': {
                this.changeToPublished(action.object);
                break;
            }
            case 'SET_TABLES_ONLINE': {
                this.loadTable(action.object);
                break;
            }
            case 'SET_PUBLISH': {
                this.setPublish();
                break;
            }
            case 'DELETE_TABLES_ONLINE': {
                this.deleteTables(action.object);
                break;
            }
            case 'SET_PUB_TABLES': {
                this.setPublishTables(action.object);
                break;
            }
            default: {
                break;
            }
        }
    }
}

const tableStore = new TableStore();
dispatcher.register(tableStore.actionHandler.bind(tableStore));

export default tableStore;


// WEBPACK FOOTER //
// ./src/store/tableStore.js